/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Customer } from '../../models/customer';

export interface FindCustomers$Params {

/**
 * Space-separated string. Every part of it is searched in every of the fields '*lastName*', '*firstName*', '*animalName*', '*keyword*'
 */
  searchStr?: string;

/**
 * Last name (or any part of it). Will be searched for as '*lastName*'
 */
  lastName?: string;

/**
 * First name (or any part of it). Will be searched for as '*firstName*'
 */
  firstName?: string;

/**
 * Animal name (or any part of it). Will be searched for as '*animalName*'
 */
  animalName?: string;

/**
 * Keyword (or any part of it). Will be searched for as '*keyword*'
 */
  keyword?: string;

/**
 * Should the query result include the customer's animals?
 */
  withAnimals?: boolean;

/**
 * Should the query result include inactive customers
 */
  withInactive?: boolean;

/**
 * Max. number of returned customers. Allowed values 0 < count <= 100
 */
  count?: number;
}

export function findCustomers(http: HttpClient, rootUrl: string, params?: FindCustomers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Customer>>> {
  const rb = new RequestBuilder(rootUrl, findCustomers.PATH, 'get');
  if (params) {
    rb.query('searchStr', params.searchStr, {});
    rb.query('lastName', params.lastName, {});
    rb.query('firstName', params.firstName, {});
    rb.query('animalName', params.animalName, {});
    rb.query('keyword', params.keyword, {});
    rb.query('withAnimals', params.withAnimals, {});
    rb.query('withInactive', params.withInactive, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Customer>>;
    })
  );
}

findCustomers.PATH = '/api/customers';
